import store from '@/store/store';
import HTTP from '../HTTP';

const CLIENTS_URL = 'clients';

export async function browseClients(type, sousType) {
  try {
    const societeId = store.getters['user/idSociete'];
    const response = await HTTP.get(CLIENTS_URL, { params: { type, sousType, societeId } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function browseClientsByQuery(query, type, sousType) {
  try {
    const societeId = store.getters['user/idSociete'];
    const response = await HTTP.get(CLIENTS_URL, { params: { query, type, sousType, societeId } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function browseDetailClient(num) {
  try {
    const response = await HTTP.get(CLIENTS_URL + '/' + num);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function browseDetailAllDataAffixe2Client(num) {
  try {
    const response = await HTTP.get(CLIENTS_URL + '/allData/' + num);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function addClients(data) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.post(CLIENTS_URL, data);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function updateClient(data) {
  try {
    const response = await HTTP.put(CLIENTS_URL, data);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function other() {
  try {
    const response = await HTTP.get(CLIENTS_URL);
    return response;
  } catch (e) {
    throw e;
  }
}




// WEBPACK FOOTER //
// ./src/api/clients/index.js